import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_2136_22613)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M130.43 71.786L104.177 25.9183C102.713 23.3606 99.2874 23.3606 97.8233 25.9183L71.5704 71.786C70.0202 74.4947 71.8124 77.9999 74.7473 77.9999H127.253C130.188 77.9996 131.98 74.4944 130.43 71.786Z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("path", {
  d: "M81.9523 71.7857L106.191 29.4371L104.177 25.9183C102.713 23.3606 99.2874 23.3606 97.8233 25.9183L71.5704 71.7861C70.0202 74.4944 71.8124 77.9999 74.7473 77.9999H85.1292C82.1943 77.9993 80.4021 74.494 81.9523 71.7857Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.202 66.7566C104.202 68.501 102.715 70.0328 100.972 70.0328C99.102 70.0328 97.6992 68.5014 97.6992 66.7566C97.6992 64.9698 99.102 63.4804 100.972 63.4804C102.715 63.4804 104.202 64.9698 104.202 66.7566ZM103.394 58.6728C103.394 59.9919 101.95 60.545 100.929 60.545C99.5692 60.545 98.4215 59.9919 98.4215 58.6728C98.4215 53.6098 97.8266 46.334 97.8266 41.271C97.8266 39.6117 99.1867 38.6758 100.929 38.6758C102.587 38.6758 103.99 39.6117 103.99 41.271C103.99 46.334 103.394 53.6098 103.394 58.6728Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_2136_22613",
  x: "0.458725",
  y: "-46.5413",
  width: "201.083",
  height: "195.083",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "35.2706"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.541667 0 0 0 0 0.541667 0 0 0 0 0.541667 0 0 0 0.38 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2136_22613"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2136_22613",
  result: "shape"
})))), 'AlertOperation', {
  viewBox: '0 0 202 149',
  fill: 'none'
});